// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getMessaging, onMessage} from "firebase/messaging";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { toast } from "react-toastify";

const firebaseConfig = {
  apiKey: "AIzaSyBGxtv_Rn1kDEotIIS3GNOsXRCYc6yEBYo",
  authDomain: "wealth-compounders.firebaseapp.com",
  projectId: "wealth-compounders",
  storageBucket: "wealth-compounders.firebasestorage.app",
  messagingSenderId: "95842265998",
  appId: "1:95842265998:web:84d7e050003b519739d2df",
  measurementId: "G-5950MQPPYS"
};
// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const messaging = getMessaging(app);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);


export const listenNotifications = () => {

  onMessage(messaging, (payload) => {
    // console.log(payload)

    const title = payload.notification?.title || "Notification";
    const body = payload.notification?.body || "";

    toast.info(
      <div>
        <strong>{title}</strong>
        <div>{body}</div>
      </div>
    );

  });

};